// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31u2q","footer":"styles_footer__2mz60","passCodeTooltip":"styles_passCodeTooltip__1DoOi"};